<!--
  header.type supportati:
  date, datetime, links, buttons, icons, color, numeric, valuta, discipline,
  listTessereCellComponent, progressBar, image, imageText, imageHtml,
  html, iconText, editableText, inputText, jsonObj, link.
  Se header.type e' assente o non riconosciuto, viene usato il fallback testuale (v-else).
-->
<template>
  <div class="md-layout-item">
    <v-card-title>
      <slot name="filter"></slot>
      <!-- {{title}} -->
      <v-text-field dense v-if="showSearch" v-model="search" append-icon="mdi-magnify" :label="$t('search')" single-line
        hide-details></v-text-field>
      <v-btn v-if="exportCsv && RBAC_system_EXPORT_CSV_TABLES" class="ml-3" color="primary" small
        :disabled="!tableData || tableData.length === 0 || csvHeaders.length === 0" @click="downloadCsv">
        <v-icon left small>mdi-file-delimited-outline</v-icon>
        CSV
      </v-btn>
    </v-card-title>
    <v-data-table ref="table" class="custom-datatable" :headers="headers" :items="tableData" :search="search" :dense="dense"
      :items-per-page="itemPerPage" :expanded.sync="expanded" single-expand :item-key="itemKey"
      :show-expand="expandFields ? true : null" v-model="selected" :single-select="false" :show-select="showSelect"
      :custom-filter="customSearch" :hide-default-footer="showFooter === false" :height="height"
      :fixed-header="!!height" :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-skip-backward',
        lastIcon: 'mdi-skip-forward',
        prevIcon: 'mdi-skip-previous',
        nextIcon: 'mdi-skip-next',
      }">
      <template v-slot:footer v-if="footerButtons && footerButtons.length > 0">
        <div style="position: absolute; margin-top: 2px; padding: 15px 0px" flat color="white" align="center"
          justify="space-around">
          <v-btn v-for="bottone in footerButtons" :key="bottone.text"
            @click="handle_function_call(bottone.action, bottone.parms)" :color="bottone.color" class="mx-2">
            <v-icon left color="white"> {{ bottone.icon }}</v-icon>
            {{ bottone.text }}
          </v-btn>
        </div>
      </template>
      <template v-slot:header.data-table-select="{}">
        <v-simple-checkbox v-if="showSelect" :ripple="false" :value="!flagSelected"
          @input="selectAll"></v-simple-checkbox>
      </template>
      <template v-slot:item.data-table-select="{ item, isSelected, select }">
        <v-simple-checkbox :ripple="false" :value="isSelected" :readonly="item.disabled" :disabled="item.disabled"
          @input="select($event)"></v-simple-checkbox>
      </template>

      <template v-for="header in headers" v-slot:[getSlotName(header)]="{ item }">
        <div :key="header.value + '-date'" v-if="header.type === 'date'">
          <span v-if="item[header.value] && item[header.value] !== null">{{
            new Date(item[header.value]).toLocaleDateString()
          }}</span>
        </div>
        <div :key="header.value + '-datetime'" v-else-if="header.type === 'datetime'">
          <span v-if="item[header.value] && item[header.value] !== null">{{ new
            Date(item[header.value]).toLocaleDateString() }}
            {{ new Date(item[header.value]).toLocaleTimeString() }}</span>
        </div>
        <div :key="header.value + '-links'" v-else-if="header.type === 'links'">
          <span v-for="link in item[header.value]" :key="link.url">
            <a :href="link.url" target="_blank" style="text-decoration: none">{{
              link.text
            }}</a><br /></span>
        </div>
        <div :key="header.value + '-buttons'" v-else-if="header.type === 'buttons'">
          <v-tooltip top v-for="action in item[header.value]" :key="action.icon">
            <template v-slot:activator="{ on }">
              <v-icon :color="action.color" v-on="on" style="cursor: pointer; font-size: 28px;" class="mr-1"
                @click.native="
                  handle_function_call(action.function, action.parms, item)
                ">{{ action.icon }}</v-icon>

              <a v-if="action.link" :href="action.link.url" target="_blank" :class="
                (action.link.color ? action.link.color : action.color) +
                '--text'
              " style="text-decoration: none; float: left">{{ action.link.text }}</a>
            </template>
            <span>{{ action.text ? action.text : action.function }}</span>
          </v-tooltip>
        </div>
        <div :key="header.value + '-icons'" v-else-if="header.type === 'icons'">
          <div v-for="icon in item[header.value]" :key="icon.icon">
            <v-tooltip v-if="icon.text && icon.text !== ''" top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" :color="icon.color" large class="mr-2">{{
                  icon.icon
                }}</v-icon>

                <a v-if="icon.link" :href="icon.link.url" target="_blank" style="text-decoration: none">{{ icon.link.text
                }}</a>
                <span v-if="icon && icon.label">{{ icon.label }}</span>
              </template>
              <span>{{ icon.text ? icon.text : "" }}</span>
            </v-tooltip>
            <div v-else>
              <v-icon :color="icon.color" large class="mr-2">{{
                icon.icon
              }}</v-icon>
              <a v-if="icon.link" :href="icon.link.url" target="_blank" style="text-decoration: none">{{ icon.link.text
              }}</a>
              <span v-if="icon && icon.label">{{ icon.label }}</span>
            </div>
          </div>
        </div>
        <div :key="header.value + '-discipline'" v-else-if="header.type === 'discipline'">
          <span v-for="(discipline, index) in item[header.value]" :key="discipline.id">
            <span :style="{ color: discipline.ifLIBERTAS ? '#081045' : 'red', fontWeight: discipline.ifLIBERTAS ? 'bold' : 'normal' }">{{ discipline.descr }}</span><span v-if="index < item[header.value].length - 1">, </span>
          </span>
        </div>
        <div :key="header.value + '-color'" v-else-if="header.type === 'color'">
          <div class="color-cube" v-bind:style="{ 'background-color': item[header.value] }"></div>
        </div>
        <div :key="header.value + '-numeric'" v-else-if="header.type === 'numeric'">
          <span v-if="item[header.value] !== null">
            {{ item[header.value] !== 0 ? item[header.value].toString() : "" }}
          </span>
        </div>
        <div :key="header.value + '-valuta'" v-else-if="header.type === 'valuta'">
          <span v-if="
            item[header.value] &&
            item[header.value] !== null &&
            item[header.value] !== 0
          ">{{ getValuta(item, header.value) }}</span>
        </div>
        <div :key="header.value + '-listTessereCellComponent'" v-else-if="header.type === 'listTessereCellComponent'">
          <list-tessere-cell-component :json="item[header.value]" :type="header.value" />
        </div>
        <div :key="header.value + '-certificatiCellComponent'" v-else-if="header.type === 'certificatiCellComponent'">
          <certificati-cell-component
            :json="item[header.value]"
            :type="header.value"
            :discipline-items="header.disciplineItems || []"
            @save-level="header.saveFunction ? handle_function_call(header.saveFunction, $event, item) : null"
            @open-certificate="header.certificateFunction ? handle_function_call(header.certificateFunction, $event, item) : null"
          />
        </div>
        <div :key="header.value + '-progressBar'" v-else-if="header.type === 'progressBar'">
          <span v-if="item[header.value] && item[header.value].label">{{
            item[header.value].label
          }}</span>
          <v-progress-linear v-if="item[header.value].value" color="primary"
            :value="item[header.value].value"></v-progress-linear>
        </div>
        <div :key="header.value + '-image'" v-else-if="header.type === 'image'">
          <img v-if="item[header.value]" width="auto" :height="header.height ? header.height : 40" style="
                                                                                  width: auto;
                                                                                  margin-bottom: -4px;
                                                                                  margin-top: 2px;
                                                                                " :class="{ 'clickable-image': !!header.function }" :src="
                                                                                  isDataURL(item[header.value])
                                                                                    ? item[header.value]
                                                                                    : antiCache(item[header.value])
                                                                                " @click="header.function ? handle_function_call(header.function, header.parms, item) : null" />
        </div>
        <div :key="header.value + '-imageText'" v-else-if="header.type === 'imageText'">
          <img v-if="item[header.value].image" width="auto" :height="header.height ? header.height : 40" style="
                                                                                  width: auto;
                                                                                  margin-bottom: -4px;
                                                                                  margin-top: 2px;
                                                                                " :src="
                                                                                  isDataURL(item[header.value].image)
                                                                                    ? item[header.value].image
                                                                                    : antiCache(item[header.value].image)
                                                                                " />&nbsp;<span>{{
  item[header.value].text
}}</span>
        </div>        
        <div :key="header.value + '-imageHtml'" v-else-if="header.type === 'imageHtml'">
          <img  v-if="item[header.value].image" width="auto" :height="header.height ? header.height : 40" style="float: left;
                                                                                  width: auto;
                                                                                  margin-bottom: -4px;
                                                                                  margin-top: 2px;
                                                                                " :src="
                                                                                  isDataURL(item[header.value].image)
                                                                                    ? item[header.value].image
                                                                                    : antiCache(item[header.value].image)
                                                                                " />&nbsp;<div style="float: left; margin-left: 3px; line-height:40px;" v-html="item[header.value].html"></div>
        </div>
        <div :key="header.value + '-html'" v-else-if="header.type === 'html'">
          <span v-if="item[header.value]" v-html="item[header.value]"></span>
        </div>
        <div :key="header.value + '-iconText'" v-else-if="header.type === 'iconText'">
          <span v-if="item[header.value]">
            <v-icon large v-if="item[header.value].icon" :color="item[header.value].color" class="mr-1">{{item[header.value].icon}}</v-icon>
            {{ item[header.value].text }}
          </span>
        </div>
        <div :key="header.value + '-editableText'" v-else-if="header.type === 'editableText'">
          <span v-if="!item[header.value].activeEdit">
            <v-icon color="primary" large style="cursor: pointer" class="mr-2"
              @click.native="item[header.value].activeEdit = true">mdi-pencil</v-icon>
            {{ item[header.value].value }}
          </span>
          <v-row v-else>
            <v-col cols="auto">
              <v-icon color="success" large style="cursor: pointer" class="mr-2" @click.native="
                handle_function_call(
                  item[header.value].function,
                  item[header.value].parms,
                  item
                )
              ">mdi-content-save</v-icon>
            </v-col>
            <v-col>
              <v-text-field v-model="item[header.value].value" :label="$t('edit')" hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
        </div>
        <div :key="header.value + '-inputText'" v-else-if="header.type === 'inputText'">
          <v-text-field v-model="item[header.value]" dense hide-details></v-text-field>
        </div>
        <div :key="header.value + '-jsonObj'" v-else-if="header.type === 'jsonObj'">
          <span>{{ obj2text(item[header.value]) }}</span>
        </div>
        <div :key="header.value + '-link'" v-else-if="header.type === 'link'">
          <a :href="item[header.value].url" target="_blank" style="text-decoration: none">{{ item[header.value].text
          }}</a>
        </div>
        <div :key="header.value + '-default'" v-else>
          <span>{{ item[header.value] }}</span>
        </div>
      </template>
      <template #item.data-table-expand="{ item, expand, isExpanded }">
        <td class="text-start">
          <v-btn v-if="haveExpandedContent(item, expandFields)" small icon color="black" @click="expand(!isExpanded)"
            class="v-data-table__expand-icon" :class="{ 'v-data-table__expand-icon--active': isExpanded }"
            style="background-color: transparent">
            <v-icon style="color: black">mdi-chevron-down</v-icon>
          </v-btn>
        </td>
      </template>

      <template v-if="expandFields" v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" v-if="haveExpandedContent(item, expandFields)">

          <v-row v-for="details in expandFields" :key="details" class="data-table-expanded-field">
            <v-col v-if="item[details]" cols="12">
              <div class="data-table-expanded-field__label">{{ details }}</div>
              <pre class="data-table-expanded-field__value">{{ formatExpandedValue(item[details]) }}</pre>
            </v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import listTessereCellComponent from "@/components/base/listTessereCellComponent.vue";
import certificatiCellComponent from "@/components/base/certificatiCellComponent.vue";

export default {
  name: "data-tables",
  components: {
    listTessereCellComponent,
    certificatiCellComponent,
  },
  props: {
    footerButtons: {
      default: null,
      type: Array,
    },
    headers: Array,
    tableData: Array,
    expandFields: {
      default: null,
      type: Array,
    },
    itemPerPage: {
      default: 10,
      type: Number,
    },
    showSelect: {
      default: false,
      type: Boolean,
    },
    dense: {
      default: false,
      type: Boolean,
    },
    value: {
      default: null,
      type: Array,
    },
    showHeader: {
      default: true,
      type: Boolean,
    },
    showFooter: {
      default: true,
      type: Boolean,
    },
    showSearch: {
      default: true,
      type: Boolean,
    },
    itemKey: {
      default: "",
      type: String,
    },
    height: {
      default: null,
      type: [Number, String],
    },
    exportCsv: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      expanded: [],
      singleExpand: false,
      selected: [],
      flagSelected: true,
      search: "",
      RBAC_system_EXPORT_CSV_TABLES: false,
    };
  },
  computed: {
    csvHeaders() {
      return (this.headers || []).filter(header =>
        header.value && !["data-table-select", "data-table-expand"].includes(header.value) &&
        !["buttons", "image", "color"].includes(header.type)
      );
    },
  },
  created() {
    this.RBAC_system_EXPORT_CSV_TABLES = this.checkUserRole("system", "EXPORT_CSV_TABLES");
  },
  mounted() {
    //if (this.value) this.selected = this.value;
  },
  methods: {
    downloadCsv() {
      if (!this.exportCsv || !this.checkUserRole("system", "EXPORT_CSV_TABLES")) {
        throw new Error("CSV export is not authorized");
      }
      // Use the table's own filtering, including header filters, before pagination.
      const rows = this.$refs.table.customFilterWithColumns(this.tableData || [], this.search);
      const csv = [
        this.csvHeaders.map(header => this.escapeCsvValue(header.text)).join(";"),
        ...rows.map(item => this.csvHeaders.map(header =>
          this.escapeCsvValue(this.getCsvValue(item, header))
        ).join(";")),
      ].join("\r\n");
      const blob = new Blob(["\uFEFF", csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "table-" + new Date().toISOString().replace(/[:.]/g, "-") + ".csv";
      document.body.appendChild(link);
      try {
        link.click();
      } finally {
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 0);
      }
    },
    escapeCsvValue(value) {
      let text = value == null ? "" : String(value);
      if (typeof value === "string" && (/^[\t\r\n]/.test(text) || /^[\s\u0000-\u001f]*[=+\-@]/.test(text))) {
        text = "'" + text;
      }
      return '"' + text.replace(/"/g, '""') + '"';
    },
    getCsvValue(item, header) {
      const value = item[header.value];
      if (value == null) return "";
      switch (header.type) {
        case "date":
          return value ? new Date(value).toLocaleDateString() : "";
        case "datetime":
          return value ? new Date(value).toLocaleDateString() + " " + new Date(value).toLocaleTimeString() : "";
        case "numeric":
          return value === 0 ? "" : value;
        case "valuta":
          return value ? this.getValuta(item, header.value) : "";
        case "links":
        case "icons":
        case "discipline": {
          const entries = Array.isArray(value) ? value : [value];
          return entries.map(entry => {
            if (entry == null) return "";
            if (typeof entry !== "object") return entry;
            if (header.type === "links") return entry.text;
            if (header.type === "discipline") return entry.descr;
            return [entry.label || entry.text, entry.link && entry.link.text].filter(Boolean).join(" ");
          }).join(", ");
        }
        case "link":
        case "iconText":
        case "imageText":
          return value.text;
        case "progressBar":
          return value.label;
        case "editableText":
          return value.value;
        case "html":
        case "imageHtml": {
          const element = document.createElement("template");
          element.innerHTML = header.type === "imageHtml" ? value.html || "" : value;
          return element.content.textContent;
        }
        case "jsonObj":
          return this.obj2text(value);
        default:
          return typeof value === "object" ? JSON.stringify(value) : value;
      }
    },
    customSearch(value, search, item) {
      return Object.values(item).some(v => v && v.toString().toLowerCase().includes(search.toLowerCase()))
    },
    handleExpansion(item, state) {
      const itemIndex = this.expanded.indexOf(item);

      state ? this.expanded.splice(itemIndex, 1) : this.expanded.push(item);
    },
    haveExpandedContent(item, expanded) {
      if (!item) return false;
      for (let key of expanded) {
        if (item[key] && item[key] !== "") return true
      }
      return false;
    },
    isDataURL(s) {
      let regex =
        /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
      return !!s.match(regex);
    },
    obj2text(obj) {
      let text = "";
      if (!obj) return text;
      if (Array.isArray(obj)) {
        obj = obj.map((element) => {
          if (typeof element === "object") {
            Object.keys(element).forEach((key) => {
              return key + ": " + element[key];
            });
          } else return element;
        });
        return obj.join(", ");
      } else {
        let arrProps = [];
        Object.keys(obj).forEach((key) => {
          arrProps.push(key + ": " + obj[key]);
        });
        text = arrProps.join(", ");
      }
      return text;
    },
    formatExpandedValue(value) {
      return value && typeof value === "object"
        ? JSON.stringify(value, null, 2)
        : value;
    },
    getValuta(item, column) {
      let valuta = "?";
      if (item[column + ".valuta"] === "EUR") valuta = "€";
      return Number(item[column]).toFixed(2) + " " + valuta;
    },
    getSlotName(header) {
      return "item." + header.value;
    },
    handle_function_call(function_name, parms, item = {}) {
      if (parms) item.callParms = parms;
      this.$emit(function_name, item);
    },
    selectAll() {
      if (this.flagSelected)
        this.selected = this.tableData.filter((riga) => {
          return !riga.disabled;
        });
      else this.selected = [];
      this.flagSelected = !this.flagSelected;
    },
  },
  watch: {
    value: function (newVal, oldVal) {
      let difference = oldVal
        .filter((x) => !newVal.includes(x))
        .concat(newVal.filter((x) => !oldVal.includes(x)));
      let _ = this;
      if (difference.length > 0) {
        _.selected = _.tableData.filter((riga) => {
          return newVal.includes(riga[_.itemKey]);
        });
      }
    },
    selected: {
      handler: function (newSelected) {
        let _ = this;
        let arrSelected = _.selected.map(function (item) {
          return item[_.itemKey];
        });
        this.$emit("input", arrSelected);
      },
      deep: true,
    },
  },
};
</script>
<style >
.v-data-table-header {
  display: contents !important;
}

.color-cube {
  width: 20px;
  height: 20px;
}

.clickable-image {
  cursor: pointer;
}

.data-table-expanded-field {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 8px 0;
}

.data-table-expanded-field:last-child {
  border-bottom: 0;
}

.data-table-expanded-field__label {
  font-weight: 600;
  margin-bottom: 4px;
}

.data-table-expanded-field__value {
  font-family: inherit;
  margin: 0;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.v-data-table__checkbox.v-simple-checkbox {
  visibility: hidden;
  display: none;
}

/* .custom-datatable td {
  display: table-cell;
} */
</style>